import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-secondary-50">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="text-6xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold text-secondary-900 mb-4">오류가 발생했습니다</h1>
            <p className="text-secondary-600 mb-6">
              예상치 못한 오류가 발생했습니다. 페이지를 새로고침하거나 나중에 다시 시도해 주세요.
            </p>
            <button onClick={() => window.location.reload()} className="btn btn-primary">
              페이지 새로고침
            </button>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mt-6 text-left">
                <details className="text-sm">
                  <summary className="cursor-pointer text-accent-red-600 font-semibold">
                    에러 상세 정보
                  </summary>
                  <pre className="mt-2 p-4 bg-secondary-100 rounded text-xs overflow-auto">
                    {this.state.error.toString()}
                    {'\n'}
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
